import TemplateView from '../../../../TemplateView'
import {AccessRights} from "../../../../constants";
import {PERMISSION_ICON_CLASS} from "../../../../permissions/constants";
import SimpleTooltip from '../../../../SimpleTooltip'
import messageResource from '../../../../messageResource'

class PermissionsCellContent extends TemplateView {
    constructor({
        generateMoneyReportsEnabled,
        generateMoneyReportsTooltip,
        isTTAEnabled = false,
    }) {
        super()

        this.params = {
            generateMoneyReportsEnabled,
            generateMoneyReportsTooltip,
            isTTAEnabled,
        }

        this.state = {
            canManageUsers: false,
            canModifyTime: false,
            canManageScope: false,
            canGenerateMoneyReports: false,
            generateMoneyReportsTooltip: this.params.generateMoneyReportsTooltip,
            generateMoneyReportsEnabled: this.params.generateMoneyReportsEnabled,
        }

        this.onStateChanged(() => {
            this._updateIcons()
        })

        this.onStatePropertyChanged('generateMoneyReportsEnabled', (enabled) => {
            this.costReports.toggle(enabled)
        })
    }

    templateHtml() {
        return '<div class="permissions">' +
               '  <div class="icons">' +
               '    <div class="icon <%=manageUsers%>"/>' +
               '    <div class="icon <%=modifyTT%>"/>' +
               '    <div class="icon <%=manageScope%>"/>' +
               '    <div class="icon <%=costReports%>"/>' +
               '  </div>' +
               '  <div class="tooltipPlaceholder"/>' +
               '</div>'
    }

    templateModel() {
        return {
            manageUsers: PERMISSION_ICON_CLASS[AccessRights.MANAGE_USERS],
            modifyTT: PERMISSION_ICON_CLASS[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK],
            manageScope: PERMISSION_ICON_CLASS[AccessRights.EDIT_HIERARCHY],
            costReports: PERMISSION_ICON_CLASS[AccessRights.GENERATE_MONEY_REPORTS]
        }
    }

    afterRender() {
        this.manageUsers = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.MANAGE_USERS]}`)
        this.modifyTT = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.SUBMIT_OTHER_USER_TIME_TRACK]}`)
        this.manageScope = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.EDIT_HIERARCHY]}`)
        this.costReports = this.find(`.${PERMISSION_ICON_CLASS[AccessRights.GENERATE_MONEY_REPORTS]}`)
        this.costReports.toggle(this.params.generateMoneyReportsEnabled)

        this.permissionNameTooltip = new SimpleTooltip().init(this.find('.tooltipPlaceholder'))

        this.permissionNameTooltip.subscribeToMouseEvents(this.manageUsers, () => {
            this.permissionNameTooltip.setText(messageResource.getMessage('access_rights.manage_users'))
        })
        this.permissionNameTooltip.subscribeToMouseEvents(this.modifyTT, () => {
            const msgKey = this.params.isTTAEnabled ? 'access_rights.modify_and_approve_tt' : 'access_rights.submit_other_time_track'
            this.permissionNameTooltip.setText(messageResource.getMessage(msgKey))
        })
        this.permissionNameTooltip.subscribeToMouseEvents(this.manageScope, () => {
            this.permissionNameTooltip.setText(messageResource.getMessage('access_rights.edit_hierarchy'))
        })
        this.permissionNameTooltip.subscribeToMouseEvents(this.costReports, () => {
            this.permissionNameTooltip.setText(this.state.generateMoneyReportsTooltip)
        })
    }
    
    _updateIcons() {
        this.manageUsers.toggleClass('inactive', !this.state.canManageUsers)
        this.modifyTT.toggleClass('inactive', !this.state.canModifyTime)
        this.manageScope.toggleClass('inactive', !this.state.canManageScope)
        this.costReports.toggleClass('inactive', !this.state.canGenerateMoneyReports)
    }
}

export default PermissionsCellContent



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PermissionsCellContent.js